import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions /* eslint-disable-line no-unused-vars */ } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC6GL9w2pS6DB6dOezrmwI5PZglJa1jSs0",
  authDomain: "networkchuck-beta-signup.firebaseapp.com",
  projectId: "networkchuck-beta-signup",
  storageBucket: "networkchuck-beta-signup.appspot.com",
  messagingSenderId: "719355323977",
  appId: "1:719355323977:web:37fc25ec469f6752260198"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Specify the region where your Cloud Function is deployed (us-central1)
const functions = getFunctions(app, "us-central1");

export { db, functions };
